var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIntenseTraining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.251,
    height: 106.278,
    viewBox: "0 0 101.251 106.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2642",
    "data-name": "Ret\\xE2ngulo 2642",
    width: 101.251,
    height: 106.278,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2896",
    "data-name": "Caminho 2896",
    d: "M45.611,7.445Q31.891,13.7,18.179,19.973a4.34,4.34,0,0,0-2.528,2.973C11.181,39.367,6.645,55.77,2.232,72.205c-1.155,4.3-2.437,8.608-2.2,13.179.146,2.868.751,4.034,3.447,5.018a25.833,25.833,0,0,1,6.963,3.865c2.611,2.009,5.334,3.873,8.032,5.766a50.374,50.374,0,0,0,31.381,9.533,107.089,107.089,0,0,0,20.309-2.553,2.844,2.844,0,0,1,1.681-.028,49.166,49.166,0,0,0,17.038,4.772c3.477.289,6.995.135,10.494.091a1.738,1.738,0,0,0,1.862-1.922c-.11-1.034-.928-1.619-2.2-1.545-.693.041-1.382.145-2.074.175a49.77,49.77,0,0,1-24.288-5.068,2.876,2.876,0,0,0-1.785-.234,98.5,98.5,0,0,1-19.132,2.729c-6.738.278-13.394-.173-19.766-2.645a70.366,70.366,0,0,1-14.631-8.283c-4.249-2.96-8.05-6.656-13.214-8.13-.033-.01-.078-.017-.094-.041-.165-.239-.466-.482-.464-.721a23.675,23.675,0,0,1,.2-5.181c1.855-7.823,3.782-15.633,5.867-23.4,2.965-11.046,6.1-22.047,9.134-33.074a2.333,2.333,0,0,1,1.487-1.679c2.514-1.084,4.987-2.264,7.478-3.4,6.082-2.777,12.165-5.551,18.331-8.364,2.878,3.746,5.7,7.4,8.494,11.071a1.619,1.619,0,0,1-.213,2.257c-2.687,3-5.356,6.016-8.045,9.013-.918,1.023-1.657,1.045-2.663.129-.975-.889-1.926-1.8-2.917-2.675a1.844,1.844,0,0,0-2.693.045,4.572,4.572,0,0,1-2,1.142c-1.523.279-3.1.251-4.634.479a2.345,2.345,0,0,0-1.605.841,2.661,2.661,0,0,0,.1,1.907,11.748,11.748,0,0,0,1.141,1.6,3.065,3.065,0,0,1,.461,1.317c.521,8.523.941,17.054,1.562,25.57a12.7,12.7,0,0,1-1.307,6.619,6.043,6.043,0,0,1-1.333,1.651,1.778,1.778,0,0,0-.541,2.149,1.58,1.58,0,0,0,2.068.9,5.246,5.246,0,0,0,2.158-1.809c.866-1.561,1.414-3.3,2.136-4.941a3.015,3.015,0,0,1,.84-1.225,20.824,20.824,0,0,1,25.217-.152,14.245,14.245,0,0,1,5.827,8.476,1.7,1.7,0,0,0,1.926,1.481,1.609,1.609,0,0,0,1.457-1.92,10.884,10.884,0,0,0-1-3.354c-1-1.847-2.239-3.569-3.527-5.575C68.308,64.8,69.714,63.308,71.278,62a18.667,18.667,0,0,1,12.4-4.659,25.211,25.211,0,0,1,14.415,5.012c1.187.83,2.173.8,2.822-.118s.38-1.906-.811-2.716a37.563,37.563,0,0,0-3.7-2.311c-5.038-2.628-10.344-3.98-16.062-3.1-6.325.973-11.21,4.389-15.325,9.1-.242.277-.494.546-.728.8-9.113-5.686-18.3-6.444-27.772-.8L34.89,35.92a7.642,7.642,0,0,0,2.321-.549c1.84-1.135,3.015-.413,4.377.942a4.772,4.772,0,0,0,7.059-.3q4.285-4.69,8.464-9.478a4.92,4.92,0,0,0,.238-6.5c-3.035-4.014-6.114-8-9.189-11.98a1.816,1.816,0,0,0-1.435-.908,2.756,2.756,0,0,0-1.114.3",
    transform: "translate(0 -7.143)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x2: 1.027,
    y2: 1.251,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2897",
    "data-name": "Caminho 2897",
    d: "M101.459,375.341c-.874.613-.955,1.635-.212,2.753.192.289.389.576.6.848,6.82,8.631,15.881,12.569,27.938,12.805,1.737-.232,4.66-.587,7.571-1.024a1.73,1.73,0,0,0,1.683-2.061c-.211-1.049-1.061-1.526-2.3-1.34-1.851.275-3.7.623-5.563.762-8.618.644-16.387-1.509-22.915-7.34a41.406,41.406,0,0,1-4.139-4.653,2.426,2.426,0,0,0-1.764-1.053,1.547,1.547,0,0,0-.9.3",
    transform: "translate(-100.742 -375.039)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2900",
    "data-name": "Caminho 2900",
    d: "M418.857,383.335a2.029,2.029,0,0,0-1.5,1.871,9.948,9.948,0,0,0,1.226,2.21,10.906,10.906,0,0,0,2.607,2.021,24.591,24.591,0,0,0,7.8,2.439c1.353.24,2.279-.266,2.456-1.379.167-1.047-.527-1.716-1.852-2.056-2.073-.533-4.145-1.1-6.166-1.8a4.008,4.008,0,0,1-2.668-2.434,1.4,1.4,0,0,0-1.384-.941,2.07,2.07,0,0,0-.522.07",
    transform: "translate(-417.362 -383.265)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-intense-training",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5369",
    "data-name": "Grupo 5369",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5368",
    "data-name": "Grupo 5368",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2895",
    "data-name": "Caminho 2895",
    d: "M350.9,0q7.068,8.94,14.139,17.878a1.869,1.869,0,0,1,.4,2.111,1.891,1.891,0,0,1-1.9,1.016c-1.591,0-3.182,0-4.909,0,0,1.535,0,2.982,0,4.428-.007,1.667-.586,2.248-2.26,2.25q-6.458.008-12.915,0c-1.651,0-2.244-.6-2.259-2.272-.012-1.419,0-2.837,0-4.406-1.7,0-3.32.064-4.934-.033a2.752,2.752,0,0,1-1.723-.721c-.68-.733-.427-1.588.179-2.352q7.021-8.85,14.025-17.713A.705.705,0,0,0,348.816,0Zm-1.013,4.318L339.62,17.33c.161.106.186.138.212.138.9.011,1.8.016,2.7.028,1.532.019,2.125.61,2.135,2.152.009,1.48,0,2.961,0,4.468h10.477c0-1.51-.013-2.96,0-4.41.018-1.612.61-2.2,2.2-2.209.906-.007,1.813,0,2.927,0l-10.4-13.176",
    transform: "translate(-264.378)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5371",
    "data-name": "Grupo 5371",
    transform: "translate(0 1.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5370",
    "data-name": "Grupo 5370",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2643",
    "data-name": "Ret\\xE2ngulo 2643",
    width: 101.756,
    height: 104.904,
    transform: "translate(-0.205 0)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5373",
    "data-name": "Grupo 5373",
    transform: "translate(21.031 78.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5372",
    "data-name": "Grupo 5372",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2644",
    "data-name": "Ret\\xE2ngulo 2644",
    width: 38.742,
    height: 16.708,
    transform: "translate(-0.238)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5375",
    "data-name": "Grupo 5375",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5374",
    "data-name": "Grupo 5374",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2898",
    "data-name": "Caminho 2898",
    d: "M376.588,149.565c-2.188,0-4.375.008-6.563,0-1.471-.007-2.086-.607-2.11-2.089-.024-1.527-.026-3.056,0-4.583.025-1.4.664-2.045,2.056-2.05q6.667-.022,13.334,0c1.4,0,2.025.654,2.037,2.051.014,1.563.017,3.125,0,4.688a1.746,1.746,0,0,1-1.985,1.982c-2.257.016-4.514,0-6.771,0m-5.176-3.557h10.394v-1.574H371.413Z",
    transform: "translate(-291.095 -111.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2899",
    "data-name": "Caminho 2899",
    d: "M376.713,194.528c-2.184,0-4.367.008-6.551,0-1.326-.007-2.111-.689-2.084-1.774.025-1.039.786-1.688,2.071-1.692q6.655-.018,13.31,0c1.285,0,2.022.669,2.023,1.731,0,1.079-.725,1.725-2.01,1.733-2.253.014-4.506,0-6.759,0",
    transform: "translate(-291.238 -151.166)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5377",
    "data-name": "Grupo 5377",
    transform: "translate(87.129 80.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5376",
    "data-name": "Grupo 5376",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2646",
    "data-name": "Ret\\xE2ngulo 2646",
    width: 14.255,
    height: 8.851,
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntenseTraining);
export default __webpack_public_path__ + "static/media/icon-intense-training.a54a81d6a4e5944d2d21e2fe9089adb5.svg";
export { ForwardRef as ReactComponent };